import { focusTheme } from '../utils/focusTheme';

export const ACTIVITY_STATUS_TABS = {
  remaining: 'remaining',
  completed: 'completed',
};

function ActivityStatusTabs({
  remainingCount,
  completedCount,
  remainingLabel = 'انجام نشده',
  completedLabel = 'انجام شده',
  activeTab,
  onChange,
}) {
  const tabs = [
    { id: ACTIVITY_STATUS_TABS.remaining, label: remainingLabel, count: remainingCount },
    { id: ACTIVITY_STATUS_TABS.completed, label: completedLabel, count: completedCount },
  ];

  return (
    <div
      className="grid grid-cols-2 gap-1 rounded-[8px] p-1"
      style={{ background: focusTheme.sectionBg }}
      role="tablist"
    >
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        const isRemaining = tab.id === ACTIVITY_STATUS_TABS.remaining;
        const toneClass = isRemaining ? 'text-teal-700' : 'text-emerald-700';

        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className={`rounded-[6px] px-3 py-2.5 text-right transition ${toneClass} ${
              isActive ? 'bg-white shadow-sm' : isRemaining ? 'bg-teal-50/70' : 'bg-emerald-50/70'
            }`}
          >
            <p className={`text-[12px] ${isActive ? 'font-semibold' : 'font-medium'}`}>{tab.label}</p>
            <p className="mt-1 text-[18px] font-bold">{tab.count}</p>
          </button>
        );
      })}
    </div>
  );
}

export default ActivityStatusTabs;
